import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Button,
    Select, MenuItem,
    Box, Grid, Typography
} from '@mui/material';
import TableRowActions from '../TableRowActions';
import borderStyle from '../../styles/borderStyle';
import tableStyle from '../../styles/tableStyle';
import buttonStyle from '../../styles/buttonStyle';
import RowDelete from '../RowDelete';

const firstRow = {
    description: "",
    id: 1,
    hrRate: "",
    hrs: "",
    actualHr: "",
    vat: '20.00',
    amt: ""
}
function AddLabourTask({ rows, setRows, addRow, handleDelete, deleteRowParts }) {
    // const [rows, setRows] = useState([firstRow]);
    const [hoveredRow, setHoveredRow] = useState(null);

    const handleRowMouseEnter = (rowId) => {
        setHoveredRow(rowId);
    };

    const handleRowMouseLeave = () => {
        setHoveredRow(null);
    };
    const columns = [
        { id: 'id', label: 'No' },
        { id: 'description', label: 'Labour' },
        { id: 'hrs', label: 'Hrs' },
        { id: 'hrRate', label: 'Hourly Rate' },
        { id: 'actualHr', label: 'Actual Hrs' },
        { id: 'vat', label: 'VAT' },
        { id: 'amt', label: 'Amount' },
    ];

    // const addRow = (field) => {
    //     const lastRow = rows[rows.length - 1];
    //     // Check if the last row's "name" field is empty or if it's the same as a previously added row
    //     if (!lastRow || lastRow[field] === '') {
    //       alert('Please fill in all fields before adding a new row.');
    //       return;
    //     }     
    //     // Check for duplicate names
    //     if (rows.slice(0, rows.length - 1).some((row) => row[field] === lastRow[field])) {
    //       alert('Item already added.');
    //       return;
    //     }    
    //     const newRow = { ...firstRow, id: rows.length+1 }; // Modify as needed
    //     setRows([...rows, newRow]);
    // };

    const handleFieldChange = (e, id, field) => {
        console.log(rows);
        const updatedRows = rows.map((row) => {
            if (row.id === id) {
                row[field] = e.target.value;

                // Recalculate the "Amount"
                if (field === 'actualHr') {
                    row.amt = parseFloat(parseFloat(row.actualHr) * parseFloat(row.hrRate))
                }
                // return { ...row, [field]: e.target.value };
            }
            return row;
        });
        setRows(updatedRows);
    };
    const calculateTotalAmount = () => {
        const totalAmount = rows.reduce((accumulator, row) => {
            return accumulator + parseFloat(row.amt || 0);
        }, 0);
        return totalAmount;
    };
    return (
        <TableContainer component={Paper}>
            <Table stickyHeader aria-label="sticky table" size="small" sx={{ minWidth: 1000 }}>
                <TableHead>
                    <TableRow>
                        {columns.filter(item => item.id !== 'vat').map((column) => (
                            <TableCell key={column.id} style={column.id === 'description' ? { width: 400 } : { width: 100 }}>
                                <b>{column.label}</b>
                            </TableCell>
                        ))}
                        <TableCell></TableCell> {/* Placeholder for delete button column */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id} onMouseEnter={() => handleRowMouseEnter(row.id)} onMouseLeave={() => handleRowMouseLeave(row.id)}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>
                                {/* {row.description} */}
                                {row.labourId ? row.description :
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.description}
                                    onChange={(e) => handleFieldChange(e, row.id, 'description')}
                                />
                            } 
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.hrs}
                                    onChange={(e) => handleFieldChange(e, row.id, 'hrs')}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.hrRate}
                                    onChange={(e) => handleFieldChange(e, row.id, 'hrRate')}
                                />
                            </TableCell>

                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.actualHr}
                                    onChange={(e) => handleFieldChange(e, row.id, 'actualHr')}
                                />
                            </TableCell>
                            {/* <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.vat}
                                    onChange={(e) => handleFieldChange(e, row.id, 'vat')}
                                />
                            </TableCell> */}
                            <TableCell>
                                {/* <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={row.amt}
                    onChange={(e) => handleFieldChange(e, row.id, 'amt')}
                /> */}
                                {row.amt}
                            </TableCell>

                            <TableCell>
                                <RowDelete rows={rows} rowId={row.id} setRows={setRows} firstRow={firstRow} field='vat' hoveredRow={hoveredRow} handleDelete={handleDelete} deleteRowParts={deleteRowParts} />
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell colSpan={4}><Button onClick={() => addRow({})} variant='contained' sx={{ height: '30px', backgroundColor: '#489C8F', display: 'flex', alignItems: 'center' }}>Add labour</Button></TableCell>
                        <TableCell ><b>Total</b></TableCell>
                        <TableCell >{calculateTotalAmount()}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    )
}

export default AddLabourTask


